import TvcPro from "../../../../src/events/2022/02/tvc-pro/main";
import * as React from 'react';
export default {
  TvcPro,
  React
};